/** Move up / move down / remove for a row in a reorderable list. */
export function RowControls({
  label,
  index,
  total,
  onMove,
  onRemove,
}: {
  label: string;
  index: number;
  total: number;
  onMove: (to: number) => void;
  onRemove: () => void;
}) {
  const btn =
    'flex size-11 items-center justify-center rounded-lg border border-line text-ink disabled:opacity-40';
  return (
    <div className="ml-auto flex items-center gap-1">
      <button
        type="button"
        className={btn}
        disabled={index === 0}
        aria-label={`Move ${label} up`}
        onClick={() => onMove(index - 1)}
      >
        <span aria-hidden>↑</span>
      </button>
      <button
        type="button"
        className={btn}
        disabled={index === total - 1}
        aria-label={`Move ${label} down`}
        onClick={() => onMove(index + 1)}
      >
        <span aria-hidden>↓</span>
      </button>
      <button
        type="button"
        className={`${btn} text-fail`}
        aria-label={`Remove ${label}`}
        onClick={onRemove}
      >
        <span aria-hidden>×</span>
      </button>
    </div>
  );
}
